import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'sl19',
  templateUrl: './sl19.component.html',
  styleUrls: ['./sl19.component.scss']
})
export class Sl19Component {  
  @Input() package: any;
  @Output() link = new EventEmitter<string>();
  constructor(
    private router: Router
  ) {}
  

  protected emitLink(link: string):void{
    this.link.emit(link);
  }
}
